import ProductAdvancedView from './ProductAdvancedView'

export default ProductAdvancedView
